// src/pages/TestBookHome.jsx
import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { logout } from "../../redux/actions/authActions";

const TestBookHome = () => {
  const authState = useSelector((state) => state.authReducer || {});
  const isLoggedIn = authState?.isLoggedIn || false;
  const userName = authState?.user?.name || "User";

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  // const [activeTab, setActiveTab] = useState("Immersive BookWorld");

  const handleLogout = () => {
    dispatch(logout());
    navigate("/");
  };

  // { label: "Practice Test", emoji: "🧪", link: "/testbook-practice" },
  // { label: "MCQ Test", emoji: "🧪", link: "/testbook-mcq-test" },
  // { label: "SAT Test", emoji: "🧪", link: "/testbook-sat-test" },
  // { label: "Chat History", emoji: "💭", link: "/testbook-chathistory" },

const groupNames = [
  // --- CORE TESTS & LEARNING ---
  { label: "Exams", emoji: "📝", link: "/testbook-exams" },
  { label: "Series", emoji: "📚", link: "/testbook-series" },
  { label: "Sets", emoji: "🎯", link: "/testbook-set" },
  { label: "Mock Test", emoji: "🧠", link: "/testbook-mockexamlist" },

  // --- AIR MOCK TESTS ---
  { label: "Mock AIR - JEE Mains", emoji: "🏅", link: "" },
  { label: "Mock AIR - JEE Advance", emoji: "🥇", link: "" },
  { label: "Mock AIR - NEET", emoji: "🩺", link: "" },
  { label: "Mock AIR - UPSC", emoji: "🏛️", link: "" },

  // --- TEST HISTORY ---
  { label: "MCQ Test History", emoji: "📈", link: "/testbook-historymcq" },
  { label: "Short Answer Type Test History", emoji: "📘", link: "/testbook-historysat" },

  // --- CERTIFICATES ---
  { label: "Mock Certificate", emoji: "🏆", link: "/testbook-certificates" },

  // --- ANALYSIS ---
  { label: "Analysis", emoji: "📊", link: "/testbook-analysis" },
  { label: "Results Analysis", emoji: "📉", link: "/" },

  // --- SUPPORT & COMMUNITY ---
  { label: "Doubt Clearance", emoji: "❓", link: "/testbook-doubtclearnce" },
  { label: "Test Study Forum", emoji: "💬", link: "/povify-home" },

  // --- LIVE LEARNING ---
  { label: "Live Session", emoji: "🎥", link: "/edutube/TestSeries" },

  // --- RESULTS & CREATORS ---
  { label: "Exam Results", emoji: "📄", link: "/" },
  { label: "Creators", emoji: "🧑‍🏫", link: "" },
];


  return (
    <div className="min-h-screen flex flex-col bg-black text-white font-sans">
      <header className="sticky top-0 z-50 bg-black border-b border-blue-400 px-4 py-2 flex items-center justify-between shadow-lg">
        <div className="flex flex-col">
          <div className="text-m lg:text-xl font-bold text-yellow-200">📕ThinkTestBook</div>
          <div className="text-[10px] lg:text-lg text-white">
            Your Ultimate Exam Prep Hub: Learn. Practice. Improve. Achieve Success!
          </div>
        </div>

        <div className="hidden md:flex items-left gap-3">
          {isLoggedIn ? (
            <>
              <div className="text-xs text-left text-white">{userName}</div>
              <button
                onClick={handleLogout}
                className="p-2 rounded-md bg-cyan-600 hover:bg-cyan-700 transition"
                title="Logout"
              >
                ⏻
              </button>
            </>
          ) : (
            <>
              <button
                onClick={() => navigate("/login")}
                className="px-3 py-1 rounded-full border border-white-700 text-sm text-white hover:bg-white-900"
              >
                Login
              </button>
            </>
          )}
        </div>
        <button
          onClick={() => setIsMobileMenuOpen((s) => !s)}
          className="md:hidden w-8 h-8 p-1 flex items-center justify-center text-xl text-white bg-white-500"
          aria-label="Toggle menu"
        >
          {isMobileMenuOpen ? "×" : "☰"}
        </button>
      </header>

      {/* Mobile menu content */}
      {isMobileMenuOpen && (
        <div className="md:hidden bg-cyan-500 border-b border-white-800 px-4 py-2 animate-fadeIn">
          {isLoggedIn ? (
            <div className="flex flex-row items-center justify-center gap-3">
              <span className="text-white font-medium text-xs whitespace-nowrap h-7">
                {userName}
              </span>
              <button
                onClick={handleLogout}
                className="rounded-md bg-cyan-600 hover:bg-cyan-700 w-7 h-7 flex items-center justify-center text-white"
                title="Logout"
              >
                ⏻
              </button>
            </div>
          ) : (
            <div className="flex flex-row items-center justify-center gap-6">
              <Link to="/login" className="text-white hover:text-yellow-300">
                Login
              </Link>
            </div>
          )}
        </div>
      )}

      <div className="bg-white-900/40 text-white text-sm lg:text-m py-2 mt-2 border-b border-blue-800">
        <div className="mx-auto px-3 flex flex-wrap justify-center gap-2 text-xs lg:text-lg">
          <a href="" className="hover:text-yellow-200">📅 Exam Dates</a>
          <a href="" className="hover:text-yellow-200">📝 Registration</a>
          <a href="/aicounselling" className="hover:text-yellow-200">🧠 AI Counselling</a>
          <a href="/testbook-updates" className="hover:text-yellow-200">📢 Exam Updates</a>
          <a href="/testbook-about" className="hover:text-yellow-200">ℹ️ About</a>
        </div>
      </div>

      <div className="min-h-[70vh] mt-1 mb-1 px-3 py-2 border-b border-blue-800">
        <div className="grid grid-cols-3 lg:grid-cols-5 gap-2 place-items-center">
          {groupNames.map((group) => (
            <button
              key={group.label}
              onClick={() => navigate(group.link)}
              className="flex flex-col items-center justify-center w-full px-2 py-2 rounded-md text-xs lg:text-m font-medium transition"
            >
              <span className="text-lg lg:text-xl">{group.emoji}</span>
              <span className="mt-1 text-xs lg:text-m text-center">{group.label}</span>
            </button>
          ))}
        </div>
      </div>

      <footer className="bg-black border-t border-blue-400 text-white py-4">
        <div className="mx-auto px-3 flex flex-col md:flex-row items-center justify-between gap-3">
          <div className="text-xs lg:text-sm text-yellow-200">
            © 2025 Think5Whys Global DeepTech Solutions.
          </div>
          <div className="flex flex-wrap gap-4 text-xs lg:text-sm">
            <Link to="/about-us" className="text-white hover:text-blue-700">About</Link>
            <Link to="/privacy-policy" className="text-white hover:text-blue-700">Privacy Policy</Link>
            <Link to="/terms-of-use" className="text-white hover:text-blue-700">Terms of Use</Link>
            <Link to="/contact-us" className="text-white hover:text-blue-700">Contact</Link>
          </div>
        </div>
      </footer>
    </div>
  );

};

export default TestBookHome;
